import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home/Home";
import About from "./pages/AboutUs/AboutUs";
import Services from "./pages/Services/Services";
import Careers from "./pages/Careers/Careers";
import Contact from "./pages/Contact/Contact";
import Reviews from "./pages/Reviews/Reviews";
import Faq from "./pages/Faq/Faq";
import Blog from "./pages/Blog/Blog";

export default function App() {
  return (
    <div className="scroll-smooth">
      <Navbar />

      {/* We wrap each page in a section with an ID */}
      <section id="home">
        <Home />
      </section>

      <section id="about">
        <About />
      </section>

      <section id="services">
        <Services />
      </section>

      <section id="careers">
        <Careers />
      </section>

      <section id="reviews">
        <Reviews />
      </section>

      <section id="contact">
        <Contact />
      </section>


      <section id="faq">
        <Faq />
      </section>

      <section id="blog">
        <Blog />
      </section>

      <Footer />
    </div>
  );
}